import { PdlApplications } from '@/features';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/pdl/applications/')({
  component: RouteComponent,
  staticData: {
    icon: 'FileText',
    title: 'Applications',
  },
});

function RouteComponent() {
  return <PdlApplications />;
}
